const config = {
  "Group": {
    "MaxAirMilesDollarsPerUnit": 200,
    "DiscretionarySalesChargeReturnRate": 0.08
  },
  "Self-Initiated": {
    "NomineeInsuranceAmountPerYear": 9,
    "MaxAirMilesDollarsPerUnit": 200,
    "DiscretionarySalesChargeReturnRate": 0
  },
  "Achievers": {
    "MaxAirMilesDollarsPerUnit": 200,
    "CriticallIllnessInsuranceAmount": 0,
    "NomineeInsuranceAmountPerYear": 9,
    "CompletionInsuranceAmountPerUnit": 0,
    "CostPerUnit": 465,
    "TopUpPerUnit": 3,
    "DiscretionarySalesChargeReturnRate": 0.1
  }
}


export default config;